import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: column;
  }
`;
